import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
export function Mechanism() {
  return <section className="py-16 bg-[#2B0A3D] text-white relative overflow-hidden" data-id="element-92">
      {/* Background Elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-93">
        <div className="absolute top-10 left-10 w-64 h-64 rounded-full bg-[#D4AF37] blur-3xl" data-id="element-94"></div>
        <div className="absolute bottom-10 right-10 w-96 h-96 rounded-full bg-[#D4AF37] blur-3xl" data-id="element-95"></div>
      </div>

      <div className="max-w-3xl mx-auto px-4 text-center relative z-10" data-id="element-96">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="inline-flex items-center justify-center p-3 bg-white/10 rounded-full mb-8 backdrop-blur-sm" data-id="element-97">
          <Sparkles className="w-6 h-6 text-[#D4AF37]" data-id="element-98" />
        </motion.div>

        <h2 className="text-3xl md:text-5xl font-bold mb-10 font-playfair" data-id="element-99">
          Abundancia con pies en la tierra
        </h2>

        <div className="space-y-6 text-xl md:text-2xl font-light leading-relaxed" data-id="element-100">
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} data-id="element-101">
            No es desear y ya.
          </motion.p>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} className="text-[#D4AF37]" data-id="element-102">
            Es reprogramar lo que crees, enfocar tu mente y moverte con
            intención.
          </motion.p>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.5
        }} data-id="element-103">
            Un sistema que te guía incluso cuando dudas.
          </motion.p>
        </div>
      </div>
    </section>;
}